import React, { Fragment } from 'react';
import { Button } from 'triider-components';

import { P } from './styles';

export const BlockedModal = ({ close }) => (
  <Fragment>
    <P>
      Para a sua segurança, mantenha
      {' '}
      <strong>toda a negociação</strong>
      {' '}
      no nosso chat. Bloqueamos a
      mensagem que continha o seu telefone, pois não garantimos a solução de nenhum problema sem o
      registro de todas as conversas. Se necessário,
      {' '}
      <strong>podemos entrar em contato com o profissional por você!</strong>
    </P>
    <Button centered type="button" onClick={close} outlined>
      Entendi
    </Button>
  </Fragment>
);

export const NewAmountModal = ({ reason }) => (
  <P>
    O profissional ajustou o valor do serviço após a execução pelo seguinte motivo: "
    {reason}
". Se
    você não está de acordo com esta cobrança, converse com o profissional. Contate a nossa Central
    de Ajuda, caso não consiga resolver com ele.
  </P>
);
